import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import Button from '../formfields/Button'
import JsonDebug from '../ui-elements/JsonDebug'
import FooterNavButtonFrame from '../ui-elements/FooterNavButtonFrame'
import AddButton from '../formfields/AddButton'
import YellowAlert from '../ui-elements/YellowAlert'
import Card from '../ui-elements/Card'
import RedAlert from '../ui-elements/RedAlert'
import DeleteButton from '../formfields/DeleteButton'


type Props = {
    categoryId: string
    categoryValueId: string
    formFields: ObjectStringKeyAnyValue
    setFormFields: React.Dispatch<React.SetStateAction<any>>
}

function IndividualCategoryValues({
    categoryId,
    categoryValueId,
    formFields,
    setFormFields
}: Props) {

    const {
        setShowModal
    } = useContext(GlobalContext)


    const thisCategory = formFields[categoryId]
    const thisCategoryValue = thisCategory && thisCategory['Values'] && thisCategory['Values'][categoryValueId]
    const thisCategoryValueDisplayName = thisCategoryValue && thisCategoryValue['DisplayName']

    const deleteCategoryValue = (categoryValueId: string) => {
        const newFormData = { ...formFields }
        if (newFormData[categoryId]) {
            delete newFormData[categoryId]['Values'][categoryValueId]
            setFormFields(newFormData)
        } else {
            console.error(`Category ${categoryId} not found in formFields`)
        }
    }
    
    return <div className={`border border-gray-400 rounded pl-2 pr-10 py-2 relative`}> 

        <div className={`flex flex-col gap-1`}>
            <p className={``}>{thisCategoryValueDisplayName}</p>
            {/* <p className={`text-xs italic text-gray-500`}>{categoryId}</p> */}
        </div>
        <DeleteButton
                deleteFunction={deleteCategoryValue}
                functionParams={categoryValueId}
                variant='x-icon'
                modalText='Are you sure you want to delete this category value?'
            />
    </div>
}
export default IndividualCategoryValues